import React from "react";
import styles from "./Panel.module.scss";

export const Panel = ({ children }) => (
  <div className={styles.panel}>{children}</div>
);
